import { Theme } from '@mui/material/styles';
import { buttonClasses } from '@mui/material/Button';
import { Iconify } from '../../../components/iconify';

// ----------------------------------------------------------------------

const dateList = ['DatePicker', 'DateTimePicker', 'StaticDatePicker', 'DesktopDatePicker', 'DesktopDateTimePicker', 'MobileDatePicker', 'MobileDateTimePicker'];

const timeList = ['TimePicker', 'MobileTimePicker', 'StaticTimePicker', 'DesktopTimePicker'];

const switchIcon = () => <Iconify icon="eva:chevron-down-fill" width={24} />;

const leftIcon = () => <Iconify icon="eva:arrow-ios-back-fill" width={24} />;

const rightIcon = () => <Iconify icon="eva:arrow-ios-forward-fill" width={24} />;

const calendarIcon = () => <Iconify icon="solar:calendar-mark-bold-duotone" width={24} />;

const clockIcon = () => <Iconify icon="solar:clock-circle-outline" width={24} />;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const desktopTypes = dateList.reduce((result: Record<string, any>, currentValue) => {
  result[`Mui${currentValue}`] = {
    defaultProps: {
      slots: {
        openPickerIcon: calendarIcon,
        leftArrowIcon: leftIcon,
        rightArrowIcon: rightIcon,
        switchViewIcon: switchIcon,
      },
    },
  };

  return result;
}, {});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const timeTypes = timeList.reduce((result: Record<string, any>, currentValue) => {
  result[`Mui${currentValue}`] = {
    defaultProps: {
      slots: {
        openPickerIcon: clockIcon,
        rightArrowIcon: rightIcon,
        switchViewIcon: switchIcon,
      },
    },
  };

  return result;
}, {});

export default function DatePicker(theme: Theme) {
  return {
    MuiPickersLayout: {
      styleOverrides: {
        root: {
          '& .MuiPickersLayout-actionBar': {
            [`& .${buttonClasses.root}:last-of-type`]: {
              backgroundColor: theme.palette.text.primary,
              color: theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[800],
            },
          },
        },
      },
    },

    // Date
    ...desktopTypes,

    // Time
    ...timeTypes,

    // Custom styles for PickersDay
    MuiPickersDay: {
      styleOverrides: {
        root: {
          '&:hover': {
            color: theme.palette.primary.main,
          },
          '&.MuiPickersDay-today': {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.main,
            fontWeight: 500,
            border: `1px solid transparent`,
          },
          '&.Mui-selected': {
            color: 'inherit',
            backgroundColor: 'unset',
            border: `1px solid ${theme.palette.text.secondary}`,
            '&:focus': {
              backgroundColor: 'unset',
              color: 'inherit',
            },
          },
          '&.day-unavailable': {
            backgroundColor: theme.palette.action.hover,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
              color: 'inherit',
            },
          },
          '&.day-occupied': {
            position: 'relative',
            '&:after': {
              position: 'absolute',
              content: '""',
              width: '5px',
              height: '5px',
              bottom: '5px',
              backgroundColor: theme.palette.primary.main,
              borderRadius: 5,
            },
          },
          '&.day-nonworking.Mui-disabled.MuiPickersDay-today': {
            color: `${theme.palette.common.white}`,
          },
        },
      },
    },
  };
}
